import type { GoogleAnalyticsIntegrationType } from './endpoints.js';

/**
 * GA4 Mint 2.0 integrations created via the backend-owned OAuth flow start
 * without an account/property and only become active once that pair is
 * configured. Until then the integration isn't expired - it just isn't
 * fully set up yet, even though the list endpoint reports
 * `is_refresh_token_valid: false` for it.
 */
export function isGA4IntegrationPendingConfiguration(
  integration: Pick<GoogleAnalyticsIntegrationType, 'accountId' | 'propertyId'>,
): boolean {
  return !integration.accountId || integration.propertyId === null;
}

/**
 * Whether the integration's token is usable. With the backend-owned OAuth
 * flow (ga4BackendOwnedAuth) a pending integration counts as verified, so
 * it's treated as "set up incomplete" rather than "expired"; otherwise this
 * is just `isRefreshTokenValid`.
 */
export function isGA4IntegrationVerified(
  integration: Pick<
    GoogleAnalyticsIntegrationType,
    'accountId' | 'propertyId' | 'isRefreshTokenValid'
  >,
  { isBackendOwnedAuth }: { isBackendOwnedAuth: boolean },
): boolean {
  if (!isBackendOwnedAuth) return integration.isRefreshTokenValid;
  return (
    integration.isRefreshTokenValid ||
    isGA4IntegrationPendingConfiguration(integration)
  );
}
